import axios from 'axios';
import { getToken, getTokenHeader } from '../../../screen/auth/action';
import {
  businessProfilerUrl,
  createPersonalProfilerUrl,
  getAllBloodGroupsUrl,
  getAllBrandMonthlyVolumeUrl,
  getAllBusinessBrandsRangeUrl,
  getAllBusinessIndustriesUrl,
  getAllBusinessMonthlyTurnOverUrl,
  getAllBusinessRoleUrl,
  getAllBusinessStoreTypesUrl,
  getAllBusinessTypesOfProductsUrl,
  getAllBusinessUomUrl,
  getAllCompanyProprietorsUrl,
  getAllGendersUrl,
  getAllHealthConcernsUrl,
  getAllLanguageUrl,
  getAllMealUrl,
  getAllQualificationUrl,
  getAllRealtionUrl,
} from '../api';

export const getAllCompanyProprietorsAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getAllCompanyProprietorsUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getPersonalProfilerAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(createPersonalProfilerUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const createPersonalProfilerAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(createPersonalProfilerUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const patchPersonalProfilerAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .patch(createPersonalProfilerUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const getAllGendersAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getAllGendersUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getAllQualificationAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getAllQualificationUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getAllRealtionAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getAllRealtionUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getAllLanguageAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getAllLanguageUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getAllHealthConcernsAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getAllHealthConcernsUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getAllMealAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getAllMealUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getAllBloodGroupsAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getAllBloodGroupsUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getAllBusinessRoleAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getAllBusinessRoleUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getAllBrandMonthlyVolumeAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getAllBrandMonthlyVolumeUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getAllBusinessIndustriesAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getAllBusinessIndustriesUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getAllBusinessUomAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getAllBusinessUomUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getAllBusinessStoreTypesAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getAllBusinessStoreTypesUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getAllBusinessTypesOfProductsAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getAllBusinessTypesOfProductsUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getAllBusinessBrandsRangeAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getAllBusinessBrandsRangeUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getAllBusinessMonthlyTurnOverAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getAllBusinessMonthlyTurnOverUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const createBusinessProfilerAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(businessProfilerUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const getbusinessProfilerAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(businessProfilerUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const patchbusinessProfilerAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .patch(businessProfilerUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
